module.exports = __webpack_public_path__ + "img/Desk Stationary A02.64af3c58.jpg";